import axios from "../../api/axiosInstance";
import { STATUS, extractErrorInfo, getProjectId } from "./sharedfunction";

/**
 * Fetch all user preferences for the authenticated user
 * @returns {Promise<Object>} Response object with status, data, message, or error
 */
export async function fetchUserPreferences() {
  try {
    const projectId = getProjectId();
    let url = `${process.env.REACT_APP_API_URL}/userpreference`;
    if (projectId) {
      url += `?projectId=${projectId}`;
    }

    const response = await axios.get(
      url,
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || [],
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error fetching user preferences:", error);
    return extractErrorInfo(error);
  }
}

/**
 * Add or update user preferences for different view types
 * @param {Array} data - Array of preference items to add or update
 * @param {string} data[].viewType - Unique identifier for the view type
 * @param {Object} data[].preferences - JSON object containing the preference settings
 * @returns {Promise<Object>} Response object with status, data, message, or error
 */
export async function updateUserPreferences(data) {
  try {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return {
        status: STATUS.ERROR,
        error: "Preference data must be a non-empty array",
      };
    }

    // Validate each preference item
    for (const item of data) {
      if (!item.viewType || typeof item.viewType !== 'string' || item.viewType.trim().length === 0) {
        return {
          status: STATUS.ERROR,
          error: "View type is required and cannot be empty",
        };
      }
      
      if (!item.preferences || typeof item.preferences !== 'object') {
        return {
          status: STATUS.ERROR,
          error: "Preferences must be a valid object",
        };
      }
    }

    const payload = {
      data: data
    };

    const projectId = getProjectId();
    let url = `${process.env.REACT_APP_API_URL}/userpreference`;
    if (projectId) {
      url += `?projectId=${projectId}`;
    }

    const response = await axios.post(
      url,
      payload,
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || [],
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error updating user preferences:", error);
    return extractErrorInfo(error);
  }
}

